import { ConsoleLogger } from '@proposify/frontend-observability';

export class ApiError extends Error {
  metadata?: Record<string, unknown>;

  constructor(message: string, options?: { cause?: Error; metadata?: Record<string, unknown> }) {
    super(message);
    this.name = 'ApiError';
    this.metadata = options?.metadata;

    Object.setPrototypeOf(this, ApiError.prototype);

    if (options?.cause) {
      this.cause = options.cause;
    }
    ConsoleLogger.error(message);
  }
}
